<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document"></i> 年级管理</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="80px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 申请人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="年级名称">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入年级名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区：独立一行 -->
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" @click="handleAdd"> 添加 </el-button>
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="classCount" label="班级数量"></el-table-column>
        <el-table-column prop="creatorName" label="创建人"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 添加/编辑弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
        @close="dialogVisible = false"
      >
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入名称" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { gradePage, gradeAddOrEdit, gradeDelete } from "@/api/admin";
import { formatState, downloadFile, parseDateRange } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import { MAX_PAGE_SIZE } from "@/utils/const.js";
import { omit } from "lodash";
import { mapState } from "vuex";

export default {
  name: "LeaveApproval",
  components: { PaginationBar },
  data() {
    return {
      isEdit: false, // 是否为编辑状态
      form: {
        name: "",
      },
      formRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      dialogVisible: false,
      dialogTitle: "",
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 查询参数
      queryParams: {
        name: "",
      },
      // 表格数据
      tableData: [],
    };
  },
  created() {
    this.handleQuery(1);
  },
  methods: {
    formatState,
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里添加提交逻辑
          gradeAddOrEdit(this.form).then(() => {
            this.dialogVisible = false;
            this.$message.success("提交成功");
            this.handleQuery(1);
          });
        }
      });
    },
    // 添加按钮点击事件
    handleAdd() {
      this.dialogTitle = "添加年级";
      this.isEdit = false;
      this.form = {
        name: "",
      };
      this.dialogVisible = true;
    },

    // 编辑按钮点击事件
    handleEdit(row) {
      this.dialogTitle = "编辑年级";
      this.isEdit = true;
      this.form = {
        id: row.id,
        name: row.name,
      };
      this.dialogVisible = true;
    },
    // 删除按钮点击事件
    handleDelete(row) {
      if(!row || !row.id) {
         return this.$message.success("当前数据无效，无法删除");
      }
      this.$confirm("确定要删除当前年级？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 这里调用删除API
          gradeDelete({
            id: row.id,
          }).then(() => {
            this.$message.success("删除成功");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {
          // 取消删除
        });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      gradePage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    // 重置搜索
    resetQuery() {
      this.queryParams = {
        creatorName: "",
        departmentName: "",
        type: "",
        days: undefined,
      };
      this.handleQuery(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
    font-size: 18px;
  }

  .el-table {
    .el-icon-user,
    .el-icon-office-building,
    .el-icon-document,
    .el-icon-time,
    .el-icon-date,
    .el-icon-notebook-2 {
      margin-right: 5px;
    }
  }

  .el-tag {
    .el-icon-check,
    .el-icon-loading,
    .el-icon-close {
      margin-right: 5px;
    }
  }

  .el-button {
    .el-icon-edit,
    .el-icon-delete,
    .el-icon-plus,
    .el-icon-close,
    .el-icon-check {
      margin-right: 5px;
    }
  }

  .el-select {
    .el-icon-document,
    .el-icon-first-aid-kit,
    .el-icon-date,
    .el-icon-time {
      margin-right: 5px;
    }
  }

  .demo-form-inline {
    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .search-buttons {
    margin-bottom: 20px;

    .el-button {
      margin: 0 10px;
    }
  }
}
.el-table__content {
  overflow-x: auto;
}
.el-table {
  &__header-wrapper {
    th {
      background-color: #f5f7fa !important;
      color: #333;
      font-weight: bold;
    }
  }

  &--border,
  &--group {
    border: 1px solid #dcdfe6;
  }

  .cell {
    white-space: nowrap;
  }
}
</style>
